module.exports = __webpack_public_path__ + "img/shezhi.3ee6b26e.png";